import { createSlice } from '@reduxjs/toolkit';
import { StatisticByEvent, TicketTypeDetail } from 'src/models/statistic';

interface StatisticByEventState {
  isLoading: boolean;
  isloadingTicketTypes?: boolean;
  isErrorMessage: string;
  statusCode: number;
  statisticsByEvent: StatisticByEvent[];
  activeStatisticByEvent: StatisticByEvent | {};
  statisticsByEventPaginated: StatisticByEvent[];
  pageEvt: number;
  limitEvt: number;
  total: number;
  changeStsEvent: null;
  filters: any;
  details: any;
  isLoadingDetails?: boolean;
  ticketTypeDetail: TicketTypeDetail[];
}

const initialState: StatisticByEventState = {
  isLoading: false,
  isloadingTicketTypes: false,
  statusCode: 201,
  isErrorMessage: '',
  statisticsByEvent: [],
  activeStatisticByEvent: {},
  statisticsByEventPaginated: [],
  pageEvt: 0,
  limitEvt: 25,
  total: 0,
  changeStsEvent: null,
  filters: {
    filter: {
      tktDates: {
        from: '',
        to: ''
      },
      place: '',
      state: '',
      onlyGift: false,
      user: '',
      tags: [],
      event: '',
    },
    order: {
      orderBy: 'qt',
      orderDesc: true
    }
  },
  details: [],
  isLoadingDetails: false,
  ticketTypeDetail: [],
};

export const statisticByEventSlice = createSlice({
  name: 'statisticByEvent',
  initialState,
  reducers: {
    startLoadingStatisticsByEvent: (state) => {
      state.isLoading = true;
    },
    startLoadingTicketTypes: (state) => {
      state.isloadingTicketTypes = true;
    },
    setStatisticsByEvent: (state, action) => {
      state.isLoading = false;
      state.statisticsByEvent = action.payload.results;
    },
    setStatisticsByEventPaginated: (state, action) => {
      state.isLoading = false;
      state.pageEvt = action.payload.page;
      state.total = Number(action.payload.total);
      state.statisticsByEventPaginated = action.payload.results;
    },
    setchangeStsEvent: (state, action) => {
      state.changeStsEvent = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setDetails: (state, action) => {
      state.isLoadingDetails = false;
      state.details = action.payload;
    },
    stopLoadingStatisticsByEvent: (state) => {
      state.isLoading = false;
    },
    stopLoadingTicketTypes: (state) => {
      state.isloadingTicketTypes = false;
    },
    setError: (state, action) => {
      const message = action.payload.message;
      state.statusCode = action.payload.status;
      state.isErrorMessage = message;
    },
    setTicketTypeDetail: (state, action) => {
      state.isloadingTicketTypes = false;
      state.ticketTypeDetail = action.payload;
    },
    startLoadingDetails: (state) => {
      state.isLoadingDetails = false;
    },
    stopLoadingDetails: (state) => {
      state.isLoadingDetails = false;
    },
  }
});

export const {
  startLoadingStatisticsByEvent,
  setStatisticsByEvent,
  setStatisticsByEventPaginated,
  setError,
  setchangeStsEvent,
  setFilters,
  setDetails,
  stopLoadingStatisticsByEvent,
  stopLoadingTicketTypes,
  startLoadingTicketTypes,
  setTicketTypeDetail,
  stopLoadingDetails,
  startLoadingDetails,
} = statisticByEventSlice.actions;